module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "¿Qué es un presupuesto?",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("¿Qué es un "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" presupuesto?")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Qué es un presupuesto?',
      "videoEmbed": "ADMINISTRACIONDINERO17QueEsPresupuesto (48).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Un presupuesto es una herramienta que ayuda a organizar el dinero para ser utilizado de una forma óptima. "), _c('br'), _c('br'), _vm._v(" Se convierte en un\n        "), _c('strong', [_vm._v("plan de acción")]), _vm._v(" dirigido a cumplir una meta prevista, expresada en valores y términos financieros. "), _c('br'), _c('br'), _vm._v(" Se construye registrando los\n        "), _c('strong', [_vm._v("ingresos")]), _vm._v(" y los\n        "), _c('strong', [_vm._v("gastos")]), _vm._v(" de un periodo de tiempo determinado.\n        "), _c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "autoplay": true,
      "audios": [
        'Administracion5.mp3'
      ]
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 230,
      "imaSrc": "contenido/personaje_1",
      "imaAlt": "Mujer explicando el concepto"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c815c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-17.vue
// module id = 987
// module chunks = 1